import * as React from "react";
import type { SVGProps } from "react";
const SvgClockTimeArowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={20}
    fill="none"
    viewBox="0 0 21 20" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.25 10a7.5 7.5 0 1 1 7.5 7.5M8.25 14.999h-5M5.542 17.292 3.25 15M3.25 14.999l2.292-2.292"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.333 5.832v4.583h3.75"
    />
  </svg>
);
export default SvgClockTimeArowLeft;
